import React from 'react';
import './PaymentFailedModal.scss';
import { Modal } from 'antd';
import Button from 'Components/Shared/Button/Button';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';

interface IProps {
  isVisible: boolean;
  onCancel: () => void;
  onTryAgain: () => void;
}

const PaymentFailedModal: React.SFC<IProps> = ({
  isVisible,
  onCancel,
  onTryAgain,
}) => (
  <Modal
    visible={ isVisible }
    onCancel={ onTryAgain }
    footer={ null }
  >
    <div className='payment-failed-modal'>
      <FormattedText 
        style='title'
        displayName='Ops!'
        formattedName=''
      />
      <FormattedText 
        style='text'
        displayName='Det gick lite fel när vi försökte genomföra ordern. Prova igen!'
        formattedName='order.payment.failed'
      />
      <div className='modal-button-container'>
        <Button onClick={ onTryAgain }>
          <FormattedText
            displayName='Försök igen'
            formattedName='order.button.tryagain'
          />
        </Button>
        <Button onClick={ onCancel } color='black'>
          <FormattedText
            displayName='Till startsidan'
            formattedName='global.backtostart'
          />
        </Button>
      </div>
    </div>
  </Modal>
);

export default PaymentFailedModal;


// WEBPACK FOOTER //
// ./src/pages/OrderPaymentPage/PaymentFailedModal/PaymentFailedModal.tsx